// valet-keychain-qr — thin module-local wrapper around @jq4race/api-client's
// qr-batches functions. Keeps the qr-generator module importing from its own
// `api/` folder (repo convention) instead of reaching into @jq4race/api-client
// directly from every UI file, and gives this module a single seam to mock in
// component tests.

import {
  createQrBatch as apiCreateQrBatch,
  getQrBatch as apiGetQrBatch,
  listQrBatches as apiListQrBatches,
} from '@jq4race/api-client';
import type { CreateQrBatchRequest, ListQrBatchesResponse, QrBatchResponse } from '@jq4race/shared';

export function createQrBatch(
  orgId: string,
  locationId: string,
  input: CreateQrBatchRequest,
): Promise<QrBatchResponse> {
  return apiCreateQrBatch(orgId, locationId, input);
}

export function listQrBatches(orgId: string, locationId: string): Promise<ListQrBatchesResponse> {
  return apiListQrBatches(orgId, locationId);
}

/** Reprint — regenerates the full code list from the stored batch's prefix+range. */
export function getQrBatch(
  orgId: string,
  locationId: string,
  batchId: string,
): Promise<QrBatchResponse> {
  return apiGetQrBatch(orgId, locationId, batchId);
}
